import { defineComponent as _defineComponent } from 'vue';
import { kebabCase } from "lodash";
import { computed, ref, watch } from "vue";
import { getOperatorForAlias } from "@/utils/filtering";
import DelayedInput from "@/components/Common/DelayedInput.vue";
import FilterMenuBoolean from "@/components/Common/FilterMenuBoolean.vue";
import FilterMenuInput from "@/components/Common/FilterMenuInput.vue";
import FilterMenuMultiTags from "@/components/Common/FilterMenuMultiTags.vue";
import FilterMenuRanged from "@/components/Common/FilterMenuRanged.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenu',
    props: {
        name: { default: "Menu" },
        placeholder: { default: "search for items" },
        debounceDelay: { default: 500 },
        filterClass: null,
        filterText: { default: "" },
        hasHelp: { type: Boolean },
        hasClearBtn: { type: Boolean },
        loading: { type: Boolean },
        menuType: { default: "linked" },
        searchError: { default: undefined },
        showAdvanced: { type: Boolean, default: false }
    },
    emits: ["update:filter-text", "on-backend-filter", "update:show-advanced", "on-search"],
    setup(__props, { emit }) {
        const props = __props;
        const validFilters = computed(() => props.filterClass.validFilters);
        const filters = computed(() => Object.fromEntries(props.filterClass.getFiltersForText(props.filterText)));
        const identifier = kebabCase(props.name);
        // Boolean for showing the help modal for the whole filter menu (if provided)
        const showHelp = ref(false);
        const formattedSearchError = computed(() => {
            if (props.searchError) {
                const { column, col, operation, op, value, val, err_msg, ValueError } = props.searchError;
                const alias = operation || op;
                const operator = alias ? getOperatorForAlias(alias) : ":";
                const formatted = {
                    filter: `${column || col}${operator}`,
                    index: alias && alias !== "eq" ? `${column || col}_${alias}` : column || col,
                    value: value || val,
                    msg: err_msg,
                    typeError: ValueError,
                };
                return formatted;
            }
            else {
                return null;
            }
        });
        /** Explicitly sets a filter: value
         * (also closes help modal for this filter if it exists)
         * @param filter the filter to set
         * @param value the value to set it to
         */
        function onOption(filter, value) {
            filters.value[filter] = value;
        }
        function onSearch() {
            const newFilterText = props.filterClass.getFilterText(filters.value);
            const newBackendFilter = props.filterClass.getFilterText(filters.value, true);
            if (props.menuType !== "linked") {
                emit("on-search", filters.value, newFilterText, newBackendFilter);
            }
            else {
                updateFilterText(newFilterText);
                onToggle();
            }
        }
        function onToggle() {
            emit("update:show-advanced", !props.showAdvanced);
        }
        function updateFilterText(newFilterText) {
            emit("update:filter-text", newFilterText);
        }
        // as the filterText changes, emit a backend-filter that can be used as a backend query
        watch(() => props.filterText, (newFilterText) => {
            const defaultBackendFilter = props.filterClass.getFilterText(props.filterClass.defaultFilters, true);
            const currentBackendFilter = props.filterClass.getFilterText(filters.value, true);
            const backendFilter = defaultBackendFilter === currentBackendFilter
                ? `${defaultBackendFilter && !newFilterText.includes(defaultBackendFilter)
                    ? defaultBackendFilter + " "
                    : ""}` + newFilterText
                : props.filterClass.getFilterText(filters.value, true);
            emit("on-backend-filter", backendFilter);
        });
        return { __sfc: true, props, emit, validFilters, filters, identifier, showHelp, formattedSearchError, onOption, onSearch, onToggle, updateFilterText, DelayedInput, FilterMenuBoolean, FilterMenuInput, FilterMenuMultiTags, FilterMenuRanged };
    }
});
